import React, { useEffect, useState } from "react";
import OthersProfile from "container/portfolio/OthersProfile";
import OthersOutfitListForUser from "container/portfolio/OthersOutfitListForUser";
import OthersOutfitListForGuest from "container/portfolio/OthersOutfitListForGuest";
import WrongPathErrorView from "presentational/error/WrongPathErrorView";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";
import PropTypes from "prop-types";

OthersPortfolio.propTypes = {
  ownerName: PropTypes.string.isRequired
};

function OthersPortfolio(props) {
  const {
    ownerName,
    hasLoggedIn,
    UserProfileActions,
    AppErrorActions,
    getIdTokenWT
  } = props;
  const [isUserExist, setIsUserExist] = useState("pending");

  useEffect(() => {
    checkUserExist();
  }, []);

  const checkUserExist = async () => {
    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) return null;

    try {
      const { isExist } = await UserProfileActions.changeUserProfile({
        name: ownerName,
        idToken
      });
      if (isExist) {
        setIsUserExist("yes");
      } else {
        setIsUserExist("no");
      }
    } catch (error) {
      setIsUserExist("no");
      AppErrorActions.setSafeAppError(error);
    }
  };

  return (
    <div>
      {isUserExist === "yes" && (
        <div>
          <OthersProfile ownerName={ownerName} />
          {hasLoggedIn ? (
            <OthersOutfitListForUser ownerName={ownerName} />
          ) : (
            <OthersOutfitListForGuest ownerName={ownerName} />
          )}
        </div>
      )}
      {isUserExist === "no" && <WrongPathErrorView />}
    </div>
  );
}

export default withToken(
  withStore({
    stateMap: { myAccount: ["hasLoggedIn"] },
    dispatchMap: ["userProfile", "appError"]
  })(OthersPortfolio)
);
